<tec-tile [title]="'PANEL.PROCESSES' | translate" [loading]="loading()">
	@if (rolePermissions.canViewPanelDeveloperCurl()) {
		<ng-container actions>
			<tec-button-icon
				icon="icon-code-brackets"
				type="default"
				size="sm"
				(clickEvent)="openCurlModal()"
			/>
		</ng-container>
	}
	<tec-chart-line [dataset]="dataset" [labels]="labels" />
</tec-tile>

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_GRAPH_PROCESS'"
		[curlText]="getGraphProcessCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
